import type { ExperimentStatus } from "@globals";
import type { MantineColor } from "@mantine/core";

export const experimentStatusColorMap = new Map<ExperimentStatus | "draft", MantineColor>([
  ["draft", "gray"],
  ["created", "green"],
  ["configuration_changed", "orange"],
  ["recommending", "var(--mantine-primary-color-filled)"],
  ["waiting", "var(--mantine-primary-color-filled)"],
  ["stopped", "red"],
  ["error", "red"],
  ["retraining", "var(--mantine-primary-color-filled)"],
  ["retraining_error", "red"]
]);
